import React, { FormEvent, useState } from 'react'
import Link from 'next/link'
import { useIntl, FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import { getAccountExist } from 'src/effects/ForgotPassword/selectors'
import { forgotPasswordRequestAction } from 'src/effects/ForgotPassword/actions'
import { useSystem } from 'src/hooks/useSystem'
import { validateEmail } from 'client/helpers/Form'

import MessageTerms from 'client/components/MessageTerms'
import { ButtonPrimary } from '../Button/styles'
import { getMessage } from '../LoginForm/messages'

import messages from './messages'

import styles from './styles.module.css'
import Input from '../Atom/Inputs/Input/Input'

type ErrorsType = {
  email: ReturnType<typeof validateEmail>
}

const ForgotPasswordForm = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const { apiHostName } = useSystem()
  const accountExist = useSelector(getAccountExist)

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<ErrorsType>({
    email: null,
  })

  function validForm() {
    const error = { email: validateEmail(email, { required: true }) }

    setErrors(error)
    return !error.email
  }

  function handleSubmitForm(event: FormEvent) {
    event.preventDefault()
    event.stopPropagation()

    if (!validForm()) {
      return
    }

    dispatch(forgotPasswordRequestAction({ hostname: apiHostName, data: { email } }))
  }

  const valueEmail = { email: <strong>{email}</strong> }

  return (
    <div className={styles.forgotPasswordBase}>
      <div className={styles.wrapper}>
        {accountExist ? (
          <>
            <header className={styles.header}>
              <h1 className={styles.title}>{intl.formatMessage(messages.linkSent)}</h1>
            </header>
            <div className={styles.container}>
              <FormattedMessage {...messages.accountExist} tagName="p" />

              <ol>
                <FormattedMessage {...messages.forgotStep1} tagName="li" values={valueEmail} />
                <FormattedMessage {...messages.forgotStep2} tagName="li" />
                <FormattedMessage {...messages.forgotStep3} tagName="li" />
              </ol>

              <Link href="/login" passHref>
                <a className={styles.link}>
                  <FormattedMessage {...messages.done} />
                </a>
              </Link>
            </div>
          </>
        ) : (
          <>
            <header className={styles.header}>
              <h1 className={styles.title}>{intl.formatMessage(messages.forgottenPassword)}</h1>
            </header>
            <div className={styles.container}>
              <FormattedMessage {...messages.enterEmailSendLink} tagName="p" />
              <form>
                <div className={styles.field}>
                  <Input
                    errors={errors.email
                      ?.slice(0, 1)
                      ?.map(error => intl.formatMessage({ id: getMessage(error.id) }))}
                    label={intl.formatMessage({ id: 'global.email' })}
                    name="email"
                    onChange={setEmail}
                    type="email"
                    value={email}
                    dataTestId="email-field"
                  />
                </div>

                <div className={styles.buttonContainer}>
                  <ButtonPrimary type="submit" onClick={handleSubmitForm}>
                    <FormattedMessage {...messages.sendLink} />
                  </ButtonPrimary>
                </div>
              </form>

              <Link href="/login" passHref>
                <a rel="noopener nofollow" className={styles.link}>
                  <FormattedMessage {...messages.cancel} />
                </a>
              </Link>
            </div>
          </>
        )}
        {!accountExist && (
          <div className={styles.termsContainer}>
            <MessageTerms />
          </div>
        )}
      </div>
    </div>
  )
}

export default ForgotPasswordForm
